/**
 * Normalization
 * @param v Initial value
 * @param vmin Initial minimum
 * @param vmax Initial maximum
 * @param tmin Transformed minimum
 * @param tmax Transformed maximum
 * @return Transformed value
 * @example normalize(0.5, -1, 1, 10, 20); // 17.5
 */
export function normalize(v: number, vmin: number, vmax: number, tmin: number, tmax: number): number {
  // Check if inputs are numbers and within acceptable ranges
  if (
    typeof v !== "number" ||
    typeof vmin !== "number" ||
    typeof vmax !== "number" ||
    typeof tmin !== "number" ||
    typeof tmax !== "number"
  ) {
    throw new Error("All input parameters must be of type number.");
  }

  if (vmin >= vmax || tmin >= tmax) {
    return Number.NaN; // Return NaN for invalid ranges
  }

  const NV = Math.max(Math.min(v, vmax), vmin);
  const DV = vmax - vmin;
  const PC = (NV - vmin) / DV;
  const DT = tmax - tmin;

  return tmin + PC * DT;
}
